"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowImportError_1 = require("../model/WindowImportError");

var WindowImportErrorConverter_1 = require("./WindowImportErrorConverter");
/**
 * @author OPt
 */


var WindowImportErrorConverterImpl =
/*#__PURE__*/
function (_WindowImportErrorCon) {
  _inherits(WindowImportErrorConverterImpl, _WindowImportErrorCon);

  function WindowImportErrorConverterImpl() {
    _classCallCheck(this, WindowImportErrorConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowImportErrorConverterImpl).apply(this, arguments));
  }

  _createClass(WindowImportErrorConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        line: source.line,
        column: source.column,
        description: source.description,
        flagMessage: source.flagMessage,
        flagMessageVars: source.flagMessageVars
      });
      return document;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowImportError_1.WindowImportError(WindowImportError_1.WindowImportError.schema.description.valueOfField(source), WindowImportError_1.WindowImportError.schema.line.valueOfField(source), WindowImportError_1.WindowImportError.schema.column.valueOfField(source), WindowImportError_1.WindowImportError.schema.flagMessage.valueOfField(source), WindowImportError_1.WindowImportError.schema.flagMessageVars.valueOfField(source));
    }
  }]);

  return WindowImportErrorConverterImpl;
}(WindowImportErrorConverter_1.WindowImportErrorConverter);

exports.WindowImportErrorConverterImpl = WindowImportErrorConverterImpl;